module.exports = __webpack_public_path__ + "static/media/mid-aroma.7cec3dd6.png";